<button type="{{isSubmit() ? 'submit' : 'button'}}"
  class="btn btn-{{outlined() ? 'outline-' : ''}}{{color()}} {{size() ? ('btn-' + size()) : ''}} {{floating() ? 'btn-floating' : ''}} {{rounded() ? 'btn-rounded' : ''}} {{lowercase() ? 'text-lowercase' : ''}} {{customClasses()}}"
  (click)="handleClick($event)"
  mdbRipple [routerLink]="routerLink()"
  [ngStyle]="styles()"
  [disabled]="loading() || disabled()">

  @if (!loading()) {
    @if (iconClass() && !iconPosRight()) {
      <i
        [ngClass]="iconClass()"
      [class.me-2]="text()"></i>
    }
    {{ text() ?? "" | translate }}
    @if (iconClass() && iconPosRight()) {
      <i
        [ngClass]="iconClass()"
      [class.ms-2]="text()"></i>
    }
  } @else {
    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    <span class="visually-hidden">Loading...</span>
  }

</button>
